import { useMediaQuery } from 'react-responsive';

const useTablet = () => {
  return useMediaQuery({
    query: '(max-width: 767px)',
  });
};

export default useTablet;
